/* eslint-disable */
import React, { useState, useEffect, useCallback } from "react";
import { Modal, Table, Tag, InputNumber, Input, Button, message } from "antd";
import { walletApi } from "../../apis";

const WalletModal = ({ open, userId, userName, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ balance: 0, data: [], total: 0 });
  const [amount, setAmount] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    if (!userId) return;
    try {
      setLoading(true);
      setData(await walletApi.getUserWallet(userId, { limit: 50 }));
    } catch {
      message.error("Failed to load wallet");
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    if (open) load();
  }, [open, load]);

  const submit = async () => {
    if (!amount) return;
    try {
      setBusy(true);
      await walletApi.adjust(userId, amount, note);
      message.success("Wallet adjusted");
      setAmount(null);
      setNote("");
      load();
    } catch (e) {
      message.error(e.response?.data?.message || "Adjustment failed");
    } finally {
      setBusy(false);
    }
  };

  const columns = [
    { title: "When", dataIndex: "createdAt", render: (v) => new Date(v).toLocaleString("en-GB") },
    {
      title: "Type",
      dataIndex: "type",
      render: (t) => <Tag color={t === "credit" ? "green" : "red"}>{t}</Tag>,
    },
    { title: "Amount", dataIndex: "amount", render: (v) => `${Number(v).toLocaleString()} EGP` },
    { title: "Reason", dataIndex: "reason" },
    { title: "Balance after", dataIndex: "balanceAfter", render: (v) => `${Number(v).toLocaleString()} EGP` },
  ];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
      title={`Wallet — ${userName || ""}`}
    >
      <div
        style={{
          background: "#FDF3E3",
          borderRadius: 12,
          padding: "16px 20px",
          marginBottom: 16,
        }}
      >
        <div style={{ fontSize: 12, color: "#9ca3af", textTransform: "uppercase" }}>
          Current balance
        </div>
        <div style={{ fontSize: 28, fontWeight: 800, color: "#7B4D12" }}>
          {Number(data.balance).toLocaleString()} EGP
        </div>
      </div>

      <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 20 }}>
        <InputNumber
          value={amount}
          onChange={setAmount}
          placeholder="Amount (+credit / -debit)"
          style={{ width: 200 }}
        />
        <Input
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Note (optional)"
          style={{ flex: 1 }}
        />
        <Button type="primary" onClick={submit} loading={busy} disabled={!amount}>
          Adjust
        </Button>
      </div>

      <Table
        rowKey="id"
        size="small"
        loading={loading}
        columns={columns}
        dataSource={data.data}
        pagination={{ pageSize: 8 }}
      />
    </Modal>
  );
};

export default WalletModal;
